export const isHTMLEmpty = (value: string) => {
  if (!value || value.length === 0) return true;

  const domParser = new DOMParser();
  const parsedValue = domParser.parseFromString(value, 'text/html');
  const parsedValueText = parsedValue.body.textContent;

  return parsedValueText.trim().length === 0;
};
